import { CFQ_DOMAINS } from '../base/constants';
import { IEvaluationState, statePropName } from './slice';
import { getLastEvaluationTimestamp } from './utils';

export interface IAppState {
  // this feature state
  [statePropName]: IEvaluationState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getFeatureState = (state: IAppState) => state[statePropName];

export const isFeatureReady = (state: IAppState) => getFeatureState(state).evaluationReady;

export const areHighscoresReady = (state: IAppState) => getFeatureState(state).highscoresReady;

export const getDomainResults = (state: IAppState, domain: number) => getFeatureState(state).evaluation[domain];

export const getHighscores = (state: IAppState) => getFeatureState(state).highscores;

export const getSingleExerciseHighscores = (state: IAppState) => getFeatureState(state).singleExerciseHighscores;

export const getAmountOfGameplaysForSingleExercise = (state: IAppState) => {
  const highscores = getSingleExerciseHighscores(state);
  return highscores.reduce((counter, entry) => {
    return counter + entry.timesTrained;
  }, 0);
};

export const areSingleExerciseHighscoresReady = (state: IAppState) =>
  getFeatureState(state).singleExerciseHighscoresReady;

export const selfAssessmentResultsPresent = (state: IAppState) => {
  let dataLength = 0;
  CFQ_DOMAINS.forEach((domain) => {
    dataLength += getDomainResults(state, domain).length;
  });
  return dataLength > 0;
};

export const getRawEvaluationData = (state: IAppState) => getFeatureState(state).rawData;

export const getLastAssessmentEvaluationTimestamp = (state: IAppState) => {
  const evaluations = getRawEvaluationData(state);
  if (!evaluations || evaluations.length === 0) {
    return 0;
  }
  return getLastEvaluationTimestamp(evaluations);
};

export const getHighscoreByWorkoutId = (state: IAppState, workoutId: number) => {
  const highscores = getHighscores(state);
  return highscores.find((highscore) => highscore.workoutId === workoutId)?.highscore;
};
